import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import RichEditorContent from 'components/RichEditorContent';

import AbstractTimelineEvent from 'components/layout/embeddedTimeline/AbstractTimelineEvent';

import TimelineHeader from './common/TimelineHeader';

class TimelineNoteSaved extends AbstractTimelineEvent {
  render() {
    const {
      intl: { messages },
    } = this.props;

    return (
      <div>
        <TimelineHeader
          creatorId={this.getDynParam('creatorId')}
          creatorAvatar={this.getDynParam('creatorAvatar')}
          creatorName={this.getDynParam('creatorName')}
          title={messages.wrote_note}
        />

        <div class="card-block">
          <RichEditorContent content={'<div>' + this.getDynParam('content', '') + '</div>'} />
        </div>
      </div>
    );
  }
}
TimelineNoteSaved.propTypes = {
  event: PropTypes.object,
};

export default injectIntl(TimelineNoteSaved);
